import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaStreetNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map